import React from 'react';
import Settings from './CanvasSettings';
import Utils from './Utils';
import _ from 'lodash';

const { interact } = window;

export default class Element extends React.Component {

    componentDidMount() {
        let clone = null;

        interact(this.element).draggable({
            inertia:    true,
            autoScroll: true,
            onstart: (event) => {

                this.element.style.opacity = 0;

                clone = document.createElement('img');
                clone.classList.add('drag-element');
                
                let size = this.props.size || Settings.defaultSize;
                const max = Settings.maxWidths[size - 1];
                clone.style.maxWidth  = max[0] + 'px';
                clone.style.maxHeight = max[1] + 'px';
                
                clone.src = 'img/element/' + this.props.src;

                let transform = 'translate(-50%,-50%)';
                // Buscamos la escala del canvas y se la aplicamos a esto
                // Apaño: Esto no es muy "Reacty" pero güeno
                const scale = Utils.scale(document.body.querySelector('.canvas'));
                if (scale !== 1) {
                    transform += ' scale(' + scale + ')';
                }

                clone.style.transform = transform;

                document.body.appendChild(clone);

                const item = {
                    id:   this.props.id,
                    src:  this.props.src,
                    size: this.props.size,
                    class: this.props.class
                }

                this.props.onElementDragStart(item, event);
            },
            onmove: (event) => {

                if (this.props.draggedElement) {
                    if (!this.props.draggedElement.canDrop) {
                        clone.classList.add('cant-drop');
                    } else {
                        clone.classList.remove('cant-drop');
                    }
                }

                clone.style.top  = event.clientY + 'px';
                clone.style.left = event.clientX + 'px';
            },
            onend: (event) => {
                if (this.element && this.element.style) {
                    this.element.style.opacity = 1;                   
                }
                document.body.removeChild(clone);
                this.props.onElementDragEnd(null, event);
            }
        });

        interact(this.image).on('tap', (event) => {
            this.props.onClick(event);
        });

        interact(this.deleteLink).on('tap', (event) => {
            this.props.onDeleteClick(event);
        });
    
    }

    shouldComponentUpdate(nextProps, nextState) {
        var s = JSON.stringify;

        if (_.isEqual(s(nextProps), s(this.props)) && _.isEqual(s(nextState), s(this.state))) {
            return false;
        }

        return true;
    }

	render() {

        let size = this.props.size || Settings.defaultSize;

        let style = {
            top: this.props.top,
            left: this.props.left,
            zIndex: this.props.zIndex ? this.props.zIndex : null
        };

        const max = Settings.maxWidths[size - 1];

        let imageStyle = { maxWidth  : max[0], maxHeight : max[1] };

        let className = 'element';

        if (this.props.selected) {
            className += ' is-selected';
        }

        if (this.props.dragging) {
            className += ' is-dragging';
        }

        if (this.props.visible) {
            className += ' is-visible';
        }

        if (this.props.cantDrop) {
            className += ' cant-drop';
        }

        if (this.props.class) {
            className += ' '+ this.props.class;
        }

        const deleteLinkStyle = {
            display: this.props.selected ? 'block' : 'none'
        };

        // console.log(this.props.space);

		return (
            <div className={className} style={style} ref={el => this.element = el} >
                
                <img src={'img/element/' + this.props.src} style={imageStyle} role="presentation" ref={el => this.image = el}  onClick={this.props.onClick}  />

                <a onClick={this.props.onDeleteClick} className="delete" ref={el => this.deleteLink = el} style={deleteLinkStyle}><i className="icon-bin"></i></a>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Element.js